import { ImagesIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AddImage = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ImagesIcon {...rest} size={Sizes[size]} color={fill} />;
};

AddImage.displayName = 'AddImage';
